import axios from "axios";
import AxiosInstance1 from "./AxiosInstance/AxiosInstance1";

const fetchUserProfile = async (accessToken) => {
  const email = sessionStorage.getItem("email");
  try {
    var url = `/api/UserProfile/Get?emailId=${email}`;
    const userProfileResponse = await AxiosInstance1.get(url);
    // const userProfileResponse = await axios.get(
    //   // `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/UserProfile/Get?emailId=${email}`,
    //   `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/UserProfile/Get?emailId=${email}`,
    //   {
    //     headers: {
    //       Authorization: `Bearer ${accessToken}`
    //     }
    //   }
    // );

    const userProfileData = userProfileResponse.data.data;
    sessionStorage.setItem("user", JSON.stringify(userProfileData));
    if (userProfileData && userProfileData.employeeId) {
      await fetchProfileImage(accessToken, userProfileData.employeeId);
    }

    return userProfileData;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw new Error("Failed to fetch user profile data");
  }
};

const fetchProfileImage = async (accessToken, employeeId) => {
  
  try {
    var url = `/api/FileUpDown/GetProfileImage?logID=${employeeId}`;
    const profileImageResponse = await AxiosInstance1.get(url);    
    // const profileImageResponse = await axios.get(
    //   `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/FileUpDown/GetProfileImage?logID=${employeeId}`,
    //   {
    //     headers: {
    //       Authorization: `Bearer ${accessToken}`,
    //       Accept: "*/*"
    //     }
    //   }
    // );
    var imgurl = `${profileImageResponse.data}?${new Date().getTime()}`; // Append timestamp to prevent caching
    sessionStorage.setItem("UserProfilePic", profileImageResponse.data);

    console.log("Profile image fetched successfully:", profileImageResponse.data);
  } catch (error) {}
};

export default fetchUserProfile;
